import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SliderModule } from '@shopping-angular-components/slider';
import { EvaButtonModule } from '../eva-button/eva-button.module';
import { OffersModule } from '../offers/offers.module';
import { TagTextModule } from '../tag-text/tag-text.module';
import { ChatAIMessageComponent } from './chat-AI-message.component';
import { ChatAIComponent } from './chat-AI.component';
import {IconsModule} from "../icons/icons.module";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        EvaButtonModule,
        TagTextModule,
        OffersModule,
        SliderModule,
        TranslateModule,
        IconsModule
    ],
    exports: [
        ChatAIComponent
    ],
    declarations: [
        ChatAIComponent,
        ChatAIMessageComponent
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ChatAIModule { }
